/* =========================================================
   POP-UP JEU
   Capture prénom + e-mail, tirage réellement aléatoire, révélation du lot.
   Le pop-up revient à chaque chargement de page. Une personne qui a déjà
   joué retrouve son lot, elle ne retire pas : le résultat est mémorisé.
   ========================================================= */
(function () {
  'use strict';

  var racine = document.querySelector('[data-jeu]');
  if (!racine) return;

  var CLE = 'gustave_jeu';
  var HEURES = parseInt(racine.dataset.heures || '48', 10);
  var DELAI = parseInt(racine.dataset.delai || '45', 10) * 1000;
  var SORTIE = racine.dataset.sortie === '1';
  var SEUIL = parseInt(racine.dataset.scroll || '40', 10);   /* % de page lue */

  /* Filet de sécurité : si aucun lot n'est configuré dans le thème,
     on retombe sur une répartition connue plutôt que sur rien. */
  var LOTS_SECOURS = [
    { remise: '20', code: 'BQNTEV', poids: 65 },
    { remise: '30', code: 'TRPLUQ', poids: 30 },
    { remise: '50', code: 'FZKAJO', poids: 5 }
  ];

  var LOTS = (function () {
    try {
      var l = JSON.parse(racine.dataset.lots || '[]');
      var propres = [];
      for (var i = 0; i < l.length; i++) {
        if (l[i] && l[i].code && l[i].remise && l[i].poids > 0) propres.push(l[i]);
      }
      return propres.length ? propres : LOTS_SECOURS;
    } catch (e) { return LOTS_SECOURS; }
  })();

  var KLAVIYO = racine.dataset.klaviyo || '';
  var KLAVIYO_LISTE = racine.dataset.klaviyoListe || '';

  var boite = racine.querySelector('.jeu__boite');
  var doux = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function etat() {
    try { return JSON.parse(localStorage.getItem(CLE) || 'null'); } catch (e) { return null; }
  }
  function noter(v) {
    try { localStorage.setItem(CLE, JSON.stringify(v)); } catch (e) {}
  }

  /* ---------------------------------------------------------
     TIRAGE PONDÉRÉ
     --------------------------------------------------------- */
  function tirerLot() {
    var total = 0, i;
    for (i = 0; i < LOTS.length; i++) total += LOTS[i].poids;
    var seuil = Math.random() * total;
    var cumul = 0;
    for (i = 0; i < LOTS.length; i++) {
      cumul += LOTS[i].poids;
      if (seuil < cumul) return LOTS[i];
    }
    return LOTS[LOTS.length - 1];
  }

  /* ---------------------------------------------------------
     KLAVIYO
     Le lot tiré est écrit sur le profil : c'est lui que la séquence de
     relance rappelle dans chaque e-mail, et sa présence sert de filtre
     d'entrée. Appels côté navigateur avec la clé publique, sans jeton.
     --------------------------------------------------------- */
  function versKlaviyo(prenom, mail, lot) {
    if (!KLAVIYO) return;

    var entetes = { 'content-type': 'application/json', 'revision': '2026-07-15' };
    var proprietes = {
      code_promo: lot.code,
      remise_promo: lot.remise,
      source: 'Pop-up jeu Gustave'
    };
    var profil = {
      type: 'profile',
      attributes: { email: mail, first_name: prenom, properties: proprietes }
    };

    var ecrire = fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO, {
      method: 'POST', headers: entetes, body: JSON.stringify({ data: profil })
    }).catch(function () {});

    if (!KLAVIYO_LISTE) return;

    /* L'abonnement part après l'écriture, pour que les propriétés soient
       déjà là quand la séquence évalue son filtre d'entrée. */
    ecrire.then(function () {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO, {
        method: 'POST', headers: entetes,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Pop-up jeu Gustave',
              profile: { data: profil }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LISTE } } }
          }
        })
      });
    }).catch(function () {});
  }

  /* ---------------------------------------------------------
     OUVERTURE / FERMETURE
     --------------------------------------------------------- */
  var ouvert = false;
  var focusAvant = null;

  function ouvrir() {
    if (ouvert) return;
    ouvert = true;
    focusAvant = document.activeElement;
    racine.hidden = false;
    /* Reflow forcé plutôt que requestAnimationFrame : celui-ci est suspendu
       dans un onglet en arrière-plan, ce qui laisserait un voile invisible
       par-dessus la page avec le scroll bloqué. */
    void racine.offsetHeight;
    racine.classList.add('is-in');
    document.body.style.overflow = 'hidden';
    var premier = racine.querySelector('input, button, a[href]');
    if (premier) premier.focus({ preventScroll: true });
    document.addEventListener('keydown', auClavier);
  }

  function fermer() {
    if (!ouvert) return;
    ouvert = false;
    racine.classList.remove('is-in');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', auClavier);
    setTimeout(function () { racine.hidden = true; }, 320);
    if (focusAvant && focusAvant.focus) focusAvant.focus({ preventScroll: true });
  }

  function auClavier(e) {
    if (e.key === 'Escape') { fermer(); return; }
    if (e.key !== 'Tab') return;
    var focusables = racine.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
    var visibles = [];
    for (var i = 0; i < focusables.length; i++) {
      if (focusables[i].offsetParent !== null) visibles.push(focusables[i]);
    }
    if (!visibles.length) return;
    var premier = visibles[0];
    var dernier = visibles[visibles.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  Array.prototype.forEach.call(racine.querySelectorAll('[data-jeu-fermer]'), function (b) {
    b.addEventListener('click', fermer);
  });

  /* Ouverture à la demande depuis n'importe où dans la page. */
  document.addEventListener('click', function (e) {
    var cible = e.target.closest ? e.target.closest('[data-jeu-ouvrir]') : null;
    if (!cible) return;
    e.preventDefault();
    demarrer();
    ouvrir();
  });

  /* ---------------------------------------------------------
     ÉCRANS
     --------------------------------------------------------- */
  function montrer(nom) {
    Array.prototype.forEach.call(racine.querySelectorAll('[data-jeu-ecran]'), function (ec) {
      ec.hidden = ec.dataset.jeuEcran !== nom;
    });
    boite.dataset.ecran = nom;
  }

  /* Écran de départ : le formulaire, ou le lot déjà gagné. */
  function demarrer() {
    var memo = etat();
    if (memo && memo.gagne && memo.code) {
      afficherLot({ remise: memo.remise, code: memo.code }, memo.prenom, memo.fin, false);
    } else {
      montrer('form');
    }
  }

  /* ---------------------------------------------------------
     ÉCRAN 1 : LE FORMULAIRE
     --------------------------------------------------------- */
  var form = racine.querySelector('[data-jeu-form]');
  var champErreur = racine.querySelector('[data-jeu-erreur]');
  var champPrenom = racine.querySelector('#jeu-prenom');
  var champMail = racine.querySelector('#jeu-mail');
  var champConsent = racine.querySelector('[data-jeu-consent]');

  function erreur(txt) {
    champErreur.textContent = txt;
    champErreur.hidden = false;
  }

  /* Écoute en capture sur le document : notre contrôle passe avant le script
     anti-spam de Shopify, branché lui en bulle sur la fenêtre. */
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;

    /* On coupe systématiquement l'envoi par défaut. La protection Shopify
       annule elle aussi le submit d'un formulaire qui vise une iframe, mais
       sans jamais le relancer : on pilote donc l'envoi nous-mêmes. */
    e.preventDefault();
    e.stopPropagation();
    champErreur.hidden = true;

    var prenom = champPrenom.value.trim();
    var mail = champMail.value.trim();
    var stop = function (msg, cible) {
      erreur(msg);
      if (cible) cible.focus();
    };

    if (!prenom) { stop('Il nous manque votre prénom.', champPrenom); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) { stop('Cette adresse e-mail a l\'air incomplète.', champMail); return; }
    if (!champConsent.checked) { stop('Cochez la case pour qu\'on puisse vous envoyer le code.'); return; }

    racine.querySelector('[data-jeu-envoyer]').disabled = true;

    /* Le tirage a lieu maintenant, avant l'envoi : le lot part avec le client
       sous forme de tag, ce qui permet aux e-mails de relance de rappeler
       le bon code. */
    var lot = tirerLot();
    var tags = racine.querySelector('[data-jeu-tags]');
    if (tags) tags.value = 'newsletter,jeu-' + String(lot.code).toLowerCase();

    versKlaviyo(prenom, mail, lot);

    /* form.submit() ne redéclenche pas l'évènement submit : aucune boucle. */
    var envoyer = function () { try { form.submit(); } catch (err) {} };

    /* Shopify rend la main avant que le jeton anti-spam soit réellement
       rempli. Envoyer à cet instant donne une réponse « invalid parameters ».
       On laisse donc au jeton le temps d'arriver, sans bloquer indéfiniment. */
    var envoyerQuandPret = function () {
      var debut = Date.now();
      (function attendre() {
        var jeton = form.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"]');
        if (!jeton || jeton.value || Date.now() - debut > 6000) { envoyer(); return; }
        setTimeout(attendre, 200);
      })();
    };

    if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
      try { window.Shopify.captcha.protect(form, envoyerQuandPret); } catch (err) { envoyer(); }
    } else {
      envoyer();
    }

    /* L'animation n'attend pas la réponse du serveur. */
    tirer(prenom, lot);
  }, true);

  /* ---------------------------------------------------------
     ÉCRAN 2 : LE TIRAGE
     --------------------------------------------------------- */
  var MESSAGES = [
    'On réveille le chien qui tire au sort',
    'Il a renversé le bocal. On ramasse',
    'Le chat s\'est assis sur les tickets',
    'Recomptage sous l\'oeil du lapin nain',
    'Ça sent très bon pour vous'
  ];

  function tirer(prenom, lot) {
    montrer('tirage');

    var msg = racine.querySelector('[data-jeu-msg]');
    var barre = racine.querySelector('[data-jeu-barre]');
    var duree = doux ? 900 : 4200;
    var pas = duree / MESSAGES.length;

    if (doux) {
      msg.textContent = 'Tirage en cours';
      barre.style.width = '100%';
    } else {
      MESSAGES.forEach(function (t, i) {
        setTimeout(function () {
          msg.textContent = t;
          barre.style.width = Math.round(((i + 1) / MESSAGES.length) * 100) + '%';
        }, i * pas);
      });
    }

    var fin = Date.now() + HEURES * 3600 * 1000;

    setTimeout(function () {
      noter({ gagne: true, remise: lot.remise, code: lot.code, prenom: prenom, fin: fin, date: Date.now() });
      afficherLot(lot, prenom, fin, true);
    }, duree);
  }

  /* ---------------------------------------------------------
     ÉCRAN 3 : LE GAIN
     --------------------------------------------------------- */
  var texteBravo = racine.querySelector('[data-jeu-bravo]').textContent;

  function afficherLot(lot, prenom, fin, fete) {
    montrer('gain');

    racine.querySelector('[data-jeu-remise]').textContent = '-' + lot.remise + ' %';
    racine.querySelector('[data-jeu-code]').textContent = lot.code;
    racine.querySelector('[data-jeu-cta]').setAttribute('href', '/discount/' + lot.code + '?redirect=/#creer');

    var bravo = racine.querySelector('[data-jeu-bravo]');
    bravo.textContent = prenom
      ? prenom + ', ' + texteBravo.charAt(0).toLowerCase() + texteBravo.slice(1)
      : texteBravo;

    lancerCompte(fin);
    if (fete && !doux) feuxDArtifice();
  }

  function deuxChiffres(n) { return n < 10 ? '0' + n : String(n); }

  var minuterieCompte = null;

  function lancerCompte(fin) {
    var cible = racine.querySelector('[data-jeu-compte]');
    if (!cible || !fin) return;
    if (minuterieCompte) clearInterval(minuterieCompte);
    function maj() {
      var reste = Math.max(0, Math.floor((fin - Date.now()) / 1000));
      cible.textContent = deuxChiffres(Math.floor(reste / 3600)) + ':' +
                          deuxChiffres(Math.floor((reste % 3600) / 60)) + ':' +
                          deuxChiffres(reste % 60);
    }
    maj();
    minuterieCompte = setInterval(maj, 1000);
  }

  /* Copie du code */
  var copier = racine.querySelector('[data-jeu-copier]');
  if (copier) {
    copier.addEventListener('click', function () {
      var texte = racine.querySelector('[data-jeu-code]').textContent.trim();
      var fini = function () {
        var avant = copier.textContent;
        copier.textContent = 'Copié';
        copier.classList.add('is-ok');
        setTimeout(function () { copier.textContent = avant; copier.classList.remove('is-ok'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texte).then(fini, fini);
      } else {
        var z = document.createElement('textarea');
        z.value = texte; document.body.appendChild(z); z.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(z);
        fini();
      }
    });
  }

  /* ---------------------------------------------------------
     FEUX D'ARTIFICE
     Canvas léger, quelques gerbes puis arrêt complet.
     --------------------------------------------------------- */
  function feuxDArtifice() {
    var toile = racine.querySelector('[data-jeu-feux]');
    if (!toile || !toile.getContext) return;

    var ctx = toile.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var l = boite.offsetWidth;
    var h = boite.offsetHeight;
    if (!l || !h) return;
    toile.width = l * dpr;
    toile.height = h * dpr;
    toile.style.width = l + 'px';
    toile.style.height = h + 'px';
    ctx.scale(dpr, dpr);

    var TEINTES = ['#C06B4F', '#E0A860', '#8A9A7B', '#EBD3C6', '#3B4A5A'];
    var particules = [];

    function gerbe(x, y) {
      var n = 34;
      var teinte = TEINTES[Math.floor(Math.random() * TEINTES.length)];
      for (var i = 0; i < n; i++) {
        var angle = (Math.PI * 2 * i) / n + Math.random() * 0.2;
        var vitesse = 1.6 + Math.random() * 3.4;
        particules.push({
          x: x, y: y,
          vx: Math.cos(angle) * vitesse,
          vy: Math.sin(angle) * vitesse,
          vie: 1,
          taille: 1.4 + Math.random() * 2.2,
          teinte: teinte
        });
      }
    }

    var gerbes = 0;
    var rythme = setInterval(function () {
      gerbe(l * (0.15 + Math.random() * 0.7), h * (0.12 + Math.random() * 0.4));
      if (++gerbes >= 6) clearInterval(rythme);
    }, 380);
    gerbe(l / 2, h * 0.28);

    function boucle() {
      ctx.clearRect(0, 0, l, h);
      for (var i = particules.length - 1; i >= 0; i--) {
        var p = particules[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.055;      /* gravité */
        p.vx *= 0.985;
        p.vie -= 0.011;
        if (p.vie <= 0) { particules.splice(i, 1); continue; }
        ctx.globalAlpha = Math.max(p.vie, 0);
        ctx.fillStyle = p.teinte;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.taille, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (particules.length) requestAnimationFrame(boucle);
      else ctx.clearRect(0, 0, l, h);
    }
    requestAnimationFrame(boucle);
  }

  /* ---------------------------------------------------------
     DÉPART
     Le pop-up revient à chaque chargement de page, mais il attend que le
     visiteur ait lu quelque chose. Demander l'e-mail au bout de cinq
     secondes, avant même qu'il sache ce qu'on vend, ne convertit pas.
     --------------------------------------------------------- */
  demarrer();

  var dejaPropose = false;

  function proposer() {
    if (dejaPropose) return;
    dejaPropose = true;
    clearTimeout(minuterie);
    window.removeEventListener('scroll', auDefilement);
    ouvrir();
  }

  function profondeur() {
    var doc = document.documentElement;
    var total = doc.scrollHeight - doc.clientHeight;
    if (total <= 0) return 100;
    return ((window.scrollY || doc.scrollTop) / total) * 100;
  }

  function auDefilement() {
    if (profondeur() >= SEUIL) proposer();
  }

  if (SEUIL > 0) {
    window.addEventListener('scroll', auDefilement, { passive: true });
  }

  /* Filet de sécurité pour qui ne défile jamais. */
  var minuterie = setTimeout(proposer, DELAI);

  if (SORTIE) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) proposer();
    });
  }
})();
